import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@surfline/quiver-react';
import config from '../../config';
import brandToString from '../../utils/brandToString';

class RedeemConfirmation extends Component {
  getHeader = () => {
    const {
      subscription,
      redeemSuccess,
      giftProduct: {
        price,
        description,
      },
    } = this.props;
    const { funnelConfig } = config;
    const baseText = 'Success!';
    if (funnelConfig) {
      const {
        successHeader
      } = funnelConfig;
      if (redeemSuccess) return successHeader || baseText;
    }
    if (redeemSuccess) return baseText;
    if (subscription) {
      return `Apply $${price / 100} Gift Credit?`;
    }
    return `Redeem ${description}?`;
  }

  getMessage = () => {
    const {
      subscription,
      redeemSuccess,
      giftProduct: {
        name,
        price,
      }
    } = this.props;
    if (redeemSuccess && subscription) {
      return `Your $${price / 100} credit has been applied.`;
    }
    if (redeemSuccess && !subscription) {
      return `Your ${name} gift card has been applied.`;
    }
    if (subscription) {
      return `The balance will be credited to your subscription
        on the next billing period.`;
    }
    return `A ${name} gift card will immediately be applied to your account.`;
  }

  submitConfirmation = async () => {
    const { doConfirmRedemption, code } = this.props;
    await doConfirmRedemption(code);
  }

  returnToHompage = () => {
    window.location.assign(config.redirectUrl);
  }

  render() {
    const { submitting, redeemSuccess } = this.props;
    const { company } = config;
    return (
      <div className="redeem-confirmation">
        <h4>{this.getHeader()}</h4>
        <p>{this.getMessage()}</p>
        { redeemSuccess ? (
          <Button onClick={this.returnToHompage}>{`Return to ${brandToString(company)}`}</Button>
        ) : (
          <div>
            <Button loading={submitting} onClick={this.submitConfirmation}>Redeem</Button>
            <Button onClick={this.returnToHompage} type="info">Cancel</Button>
          </div>
        )}
      </div>
    );
  }
}

RedeemConfirmation.propTypes = {
  giftProduct: PropTypes.shape({}),
  subscription: PropTypes.shape({}),
  code: PropTypes.string.isRequired,
  doConfirmRedemption: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  redeemSuccess: PropTypes.bool
};

RedeemConfirmation.defaultProps = {
  giftProduct: null,
  subscription: null,
  submitting: false,
  redeemSuccess: false,
};

export default RedeemConfirmation;
